import { useEffect, useState } from 'react';
import { api } from '../../../shared/api.js';

const isValidPhone = (phone) => /^07[0-9]{9}$/.test((phone || '').replace(/\s+/g, ''));

export function useGuardianLookup(phone) {
  // settled=true فقط بعد أن يحسم البحث نتيجته للهاتف الحالي. عند إعادة تركيب
  // الخطوة (رجوع من خطوة 2) يبدأ الهوك loading=true لهاتف صالح، فلا يفسَّر
  // غياب النتيجة المؤقت على أنه "غير موجود" ويمسح الأطفال المستوردين.
  const [state, setState] = useState(() => ({
    loading: isValidPhone(phone),
    found: null,
    error: null,
    settled: false
  }));

  useEffect(() => {
    const clean = (phone || '').replace(/\s+/g, '');
    if (!/^07[0-9]{9}$/.test(clean)) {
      // هاتف غير مكتمل → "غير موجود" نهائي (يُصفّر حالة الزبون العائد).
      setState({ loading: false, found: null, error: null, settled: true });
      return undefined;
    }
    let cancelled = false;
    setState((s) => ({ ...s, loading: true, error: null, settled: false }));
    const t = setTimeout(async () => {
      try {
        const { data } = await api.get(`/guardians/by-phone/${clean}`);
        if (cancelled) return;
        const record = data?.guardian || data?.data || (data && data._id ? data : null);
        setState({ loading: false, found: record || null, error: null, settled: true });
      } catch (err) {
        if (cancelled) return;
        if (err?.response?.status === 404) {
          setState({ loading: false, found: null, error: null, settled: true });
        } else {
          // خطأ شبكة عابر: لا يُعتبر نتيجة حاسمة حتى لا يُمسح ما استورده المستخدم.
          setState({ loading: false, found: null, error: err, settled: false });
        }
      }
    }, 350);
    return () => {
      cancelled = true;
      clearTimeout(t);
    };
  }, [phone]);

  return state;
}
